import React, { Component } from 'react';
import PropTypes from 'prop-types';
import FlatTab from 'ps-components/FlatTab/FlatTab';

import './SurveyUtilizationTabs.scss';

class SurveyUtilizationTabs extends Component {
  static propTypes = {
    surveyTabChange: PropTypes.func
  };
  constructor(props) {
    super(props);

    this.state = {
      showTopSurveys: true
    };
    this.tabClick = this.tabClick.bind(this);
  }
  tabClick() {
    this.props.surveyTabChange.apply(this);
    this.setState({
      showTopSurveys: !this.state.showTopSurveys
    });
  }
  render() {
    return (
      <div className="survey__tabs">
        <FlatTab
          className={`selected__one--${this.state.showTopSurveys}`}
          title="Top 5 Surveys"
          selected={this.state.showTopSurveys}
          tabClick={this.tabClick}
          selectedClassName="survey__tabs--selected"
        />
        <FlatTab
          className={`selected__two--${!this.state.showTopSurveys}`}
          title="Bottom 5 Surveys"
          selected={!this.state.showTopSurveys}
          tabClick={this.tabClick}
          selectedClassName="survey__tabs--selected"
        />
        <hr />
      </div>
    );
  }
}

export default SurveyUtilizationTabs;
